import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from "./store/types";
import { RouterRootState } from 'connected-react-router';
import { logout } from './store/user-info/actions';

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    if (splitPath.length === 5) {
        return splitPath[3]
    }
    return splitPath[splitPath.length - 1];
}

const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = useSelector((state: IAppState) => (state.userInfo.isAuthenticated));
    const permissions = useSelector((state: IAppState) => (state.userInfo.permissions));
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));
    const dispatch = useDispatch();
    const hasAccessToRoute = permissions?.some(permission => permission.includes(routeName))

    if (hasAccessToRoute === false) {
        dispatch(logout())
    }

    return (

        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    )
};

export default PrivateRoute
